<template>
  <div class="modal nb-modal-mask" style="display:block" @keyup.esc="closeModal()">
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document" style="overflow-y: initial !important">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="def-title" id="exampleModalLabel">
            Informar xml da nota
          </h4>
          <button @click="closeModal()" class="close">
            <span>&times;</span>
          </button>
        </div>
        <div class="modal-body pt-3 d-flex justify-content-center"
          style="max-height: 100%; overflow-y: auto">
          <div class="row border d-flex justify-content-center align-items-center" style="padding: 10px;">
            <div class="col-12">
              <small class="lbl-edit">Chave Nfe</small>
              <input type="text" v-model="chave" class="form-control" ref="chave">
            </div>
            <div class="col-12">
              <small class="lbl-edit">Protocolo</small>
              <input type="text" v-model="nprot" class="form-control" ref="chave">
            </div>

            <div class="col-12">
              <small class="lbl-edit">Conteúdo XML da nota</small>
              <input type="text" v-model="xml" class="form-control" ref="nfxml" @keydown.enter="changeToNextEl()">
            </div>
          </div>

        </div>
        <div class="modal-footer">
          <v-button danger label="Cancelar" @click="closeModal()" />
          <v-button nbBtdef label="Confirmar" ref="nfxmlConfirmButton" @click="handleConfirmNfxml()" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    nf: Object,

  },
  data() {
    return {
      xml: null,
      nprot: null,
      chave: null,
    }
  },
  methods: {
   changeToNextEl() {
      this.$nextTick(function () {
        this.$refs.nfxmlConfirmButton.focus()
      })
    },
    closeModal() {
      this.$emit('close')

    },
    handleConfirmNfxml() {
      this.$emit('getNfxml', { xml: this.xml, chave: this.chave, nprot: this.nprot })
      this.closeModal();
    },

  },
  created() {
    if (this.nf.nfxml && this.nf.nfxml.length > 0) {
      this.xml = this.nf.nfxml[0].xml
      this.chave = this.nf.nfxml[0].chave
      this.nprot = this.nf.nfxml[0].nprot
    }
    this.$nextTick(function () {
      this.$refs.chave.focus()
    })


    window.addEventListener('keyup', function (event) {
      if (event.keyCode == 27) {
        this.closeModal()
      }
    })
  },

}
</script>

<style></style>



// WEBPACK FOOTER //
// src/forms/nfsaida-form-modal-nfxml.vue